// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".root__wWMcbKlG{flex:1 1 auto;height:100%}.root__wWMcbKlG > *{height:100%}.root__wWMcbKlG .truncated-data-download-text__eHByhkTf{color:var(--tertiary-text-color);font-size:$font-size-medium;font-weight:$weight-medium;padding:14px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "root__wWMcbKlG",
	"truncatedDataDownloadText": "truncated-data-download-text__eHByhkTf"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
